export default __webpack_public_path__ + "static/media/G0540.34I-26290_-22027_0.1666261680000.7b513fea.jpg";